import React, { useContext } from "react";
import { Link } from "react-router-dom";
import ITranslationsContext from "../../infrastructure/context/translations/translations-context.interface";
import TranslationsContext from "../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../infrastructure/translation-manager";
import { TranslationKeys, RouterPaths } from "../../infrastructure/const";
import CheckUtils from "../../utilities/check-utils";

const PageHeaderLinks = (): JSX.Element => {
  const translationsContext =
    useContext<ITranslationsContext>(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);
  const translations: { [key: string]: string } = {
    customerService: translationManager.getTranslation(
      TranslationKeys.HEADER_CUSTOMERSERVICE_LABEL
    ),
    instructionalVideos: translationManager.getTranslation(
      TranslationKeys.UK.HEADER_INSTRUCTIONALVIDEOS_LABEL
    ),
  };
  return (
    <ul className="links">
      {!CheckUtils.isNullOrEmptyString(translations.customerService) && (
        <li className="customer-service customer-service-desktop">
          <Link to={RouterPaths.CustomerServiceContactUs}>
            {translations.customerService}
          </Link>
        </li>
      )}
    </ul>
  );
};

export default PageHeaderLinks;
